import React, { useState } from "react";
import Axios from "axios";
import Select from "react-select";
import { useShelfContext } from "../../../context/ShelfContext";
import "./newProduct.css";

const NewProduct = () => {
  const { shelves, isFetching } = useShelfContext();

  const [formData, setFormData] = useState({
    name: "",
    quantity: "",
    barcode: "",
    part_number: "",
    initial_sale_price: "",
    last_sale_price: "",
    last_purchase_price: "",
    description: "",
    shelf_ids: [], // ✅ تغيير من shelf_id إلى shelf_ids (مصفوفة)
  });

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ تعديل لدعم اختيار متعدد
  const handleShelfChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];
    setFormData((prev) => ({
      ...prev,
      shelf_ids: selectedIds,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!formData.name.trim()) return setError("اسم الصنف مطلوب");
    if (!formData.quantity || isNaN(formData.quantity))
      return setError("الكمية مطلوبة ويجب أن تكون رقم");
    if (!formData.barcode.trim()) return setError("الباركود مطلوب");
    if (!formData.part_number.trim()) return setError("رقم القطعة مطلوب");
    if (!formData.last_sale_price || isNaN(formData.last_sale_price))
      return setError("سعر البيع مطلوب ورقم صحيح");
    if (!formData.last_purchase_price || isNaN(formData.last_purchase_price))
      return setError("سعر الشراء مطلوب ورقم صحيح");

    setIsLoading(true);
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/product/newProduct.php`,
        formData
      );

      if (res.data.status === "success") {
        setMessage(res.data.message);
        setFormData({
          name: "",
          quantity: "",
          barcode: "",
          part_number: "",
          initial_sale_price: "",
          last_sale_price: "",
          last_purchase_price: "",
          description: "",
          shelf_ids: [], // ✅ تغيير من shelf_id إلى shelf_ids
        });
      } else {
        setError(res.data.message || "حدث خطأ أثناء الإضافة");
      }
    } catch (err) {
      setError(err.response?.data?.message || "فشل الاتصال بالسيرفر");
    } finally {
      setIsLoading(false);
    }
  };

  const shelfOptions = shelves.map((shelf) => ({
    value: shelf.id,
    label: shelf.name,
  }));

  return (
    <div className="np-page">
      <div className="np-card">
        <div className="np-header">
          <h1 className="np-title">إضافة صنف جديد</h1>
          <p className="np-subtitle">
            أدخل معلومات الصنف ثم اضغط على زر الإضافة
          </p>
        </div>

        <form className="np-form" onSubmit={handleSubmit}>
          <div className="np-row">
            <div className="np-form-group">
              <label htmlFor="name" className="np-label">
                اسم الصنف <span className="np-required">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="np-input"
                placeholder="أدخل اسم الصنف"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="np-form-group">
              <label htmlFor="quantity" className="np-label">
                الكمية <span className="np-required">*</span>
              </label>
              <input
                type="text"
                id="quantity"
                name="quantity"
                className="np-input"
                placeholder="أدخل الكمية"
                value={formData.quantity}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleChange({ target: { name: "quantity", value } });
                }}
                required
              />
            </div>
          </div>

          <div className="np-row">
            <div className="np-form-group">
              <label htmlFor="barcode" className="np-label">
                الباركود <span className="np-required">*</span>
              </label>
              <input
                type="text"
                id="barcode"
                name="barcode"
                className="np-input"
                placeholder="أدخل الباركود"
                value={formData.barcode}
                onChange={handleChange}
                required
              />
            </div>

            <div className="np-form-group">
              <label htmlFor="part_number" className="np-label">
                رقم القطعة <span className="np-required">*</span>
              </label>
              <input
                type="text"
                id="part_number"
                name="part_number"
                className="np-input"
                placeholder="أدخل رقم القطعة"
                value={formData.part_number}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="np-row">
            <div className="np-form-group">
              <label htmlFor="initial_sale_price" className="np-label">
                سعر البيع الأولي
              </label>
              <input
                type="text"
                inputMode="decimal"
                id="initial_sale_price"
                name="initial_sale_price"
                className="np-input"
                placeholder="أدخل سعر البيع الأولي"
                value={formData.initial_sale_price}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleChange({
                    target: { name: "initial_sale_price", value },
                  });
                }}
              />
            </div>

            <div className="np-form-group">
              <label htmlFor="last_purchase_price" className="np-label">
                سعر الشراء الأخير <span className="np-required">*</span>
              </label>
              <input
                type="text"
                id="last_purchase_price"
                name="last_purchase_price"
                className="np-input"
                placeholder="أدخل سعر الشراء الأخير"
                value={formData.last_purchase_price}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleChange({
                    target: { name: "last_purchase_price", value },
                  });
                }}
                required
              />
            </div>

            <div className="np-form-group">
              <label htmlFor="last_sale_price" className="np-label">
                سعر البيع الأخير <span className="np-required">*</span>
              </label>
              <input
                type="text"
                id="last_sale_price"
                name="last_sale_price"
                className="np-input"
                placeholder="أدخل سعر البيع الأخير"
                value={formData.last_sale_price}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleChange({ target: { name: "last_sale_price", value } });
                }}
                required
              />
            </div>
          </div>

          {/* ✅ الرفوف - اختيار متعدد */}
          <div className="np-form-group">
            <label htmlFor="shelf_ids" className="np-label">
              اختر الرفوف (يمكن اختيار أكثر من رف)
            </label>
            <Select
              isMulti
              options={shelfOptions}
              value={shelfOptions.filter((option) =>
                formData.shelf_ids.includes(option.value)
              )}
              onChange={handleShelfChange}
              isLoading={isFetching}
              placeholder="اختر رفًا أو أكثر..."
              isClearable
              filterOption={(option, inputValue) => {
                if (!inputValue) return true;
                const searchWords = inputValue
                  .toLowerCase()
                  .split(" ")
                  .filter((w) => w);
                const optionText = option.label.toLowerCase();
                return searchWords.every((word) => optionText.includes(word));
              }}
            />
          </div>

          {/* الوصف وحده */}
          <div className="np-form-group">
            <label htmlFor="description" className="np-label">
              الوصف
            </label>
            <textarea
              id="description"
              name="description"
              className="np-textarea"
              placeholder="أدخل وصفًا اختياريًا"
              value={formData.description}
              onChange={handleChange}
              rows="3"
            ></textarea>
          </div>

          {error && <p className="np-error">{error}</p>}
          {message && <p className="np-success">{message}</p>}

          <button
            type="submit"
            className={`np-submit ${isLoading ? "loading" : ""}`}
            disabled={isLoading}
          >
            {isLoading ? <div className="np-spinner"></div> : "إضافة الصنف"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewProduct;
